import React from 'react';
import PropTypes from 'prop-types';

export default class ListingCheckList extends React.PureComponent {
    constructor(...args) {
        super(...args);
        this.onChange = this.onChange.bind(this);
    }

    onChange(changedCheckboxValue, isChecked) {
        const currentValue = this.props.value;
        let newValue = null;
        if (isChecked) {
            newValue = [...currentValue, changedCheckboxValue];
        } else {
            newValue = currentValue.filter((value) => value !== changedCheckboxValue);
        }
        this.props.onChange({ [this.props.config.name]: newValue });
    }

    render() {
        const config = this.props.config;
        return (
            <div className="checklist-round">
                <div className="checklist-round__list">
                    {config.options.map((option, index) => (
                        <div className="checklist-round__item" key={index}>
                            <div className="checkbox-round">
                                <label className="checkbox-round__label">
                                    <input className="checkbox-round__control"
                                        type="checkbox"
                                        checked={this.props.value.indexOf(option.value) !== -1}
                                        onChange={(e) => this.onChange(option.value, e.target.checked)}/>
                                    <span className="checkbox-round__inner">
                                        <span className="checkbox-round__placeholder" />
                                        <span className="checkbox-round__content">
                                            {option.text}
                                        </span>
                                    </span>
                                </label>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

ListingCheckList.defaultProps = {
    value: []
};

ListingCheckList.propTypes = {
    config: PropTypes.object.isRequired,
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
};
